// extracted by mini-css-extract-plugin
module.exports =  {"loader":"_02712f2b3b--loader--DB_jU","skeleton-animation":"_02712f2b3b--skeleton-animation--FuLus"};